import { useQuery } from '@tanstack/react-query'
import { getApiClient, ApiProblemError, type Problem } from '@/data/apiClient'
import { AVerify } from './AVerify'
import { AVerifyexp } from '@/screens/a-verifyexp/AVerifyexp'

/**
 * Not a registered unit itself — `a-verify` and `a-verifyexp` are two DIFFERENT `data-scr` units
 * sharing one operation (`identityConfirmAddressVerification`) and one outcome field. This
 * component calls it and renders whichever of the two the `outcome` names; it carries no
 * `data-cmp`/`data-scr` of its own (rule 4 — an unnamed wrapper).
 *
 * Not yet mounted from a real route: `a-verify`/`a-verifyexp` sit "outside the shell and outside
 * authentication entirely" (family rule A4) and are reached by the link's own token in the URL,
 * which needs the route table `src/routes/registry.ts` produces wired into a router (Pass 3).
 * Both screens and this entry point are built and tested now regardless.
 */
export function AddressVerificationEntry({ verification }: { verification: string }) {
  const result = useQuery({
    queryKey: ['address-verification', verification],
    queryFn: async () => {
      const client = getApiClient()
      const { data, error } = await client.POST('/auth/verifications/confirm', { body: { verification } })
      if (error) throw new ApiProblemError(error as Problem)
      return data
    },
  })

  if (result.isLoading) return null
  if (!result.data || result.data.outcome === 'EXPIRED') {
    return <AVerifyexp display={result.data?.display} />
  }
  return <AVerify display={result.data.display} />
}
